module.exports = __webpack_public_path__ + "static/color-b88cc1aa0af9551ce42fdef4b8353f71.mp4";